import React from "react";
import { cn } from "@/lib/utils";

const MARK_D = "M171.693,65.8V57.4a23.1,23.1,0,0,0,22.2-22.2h8.4a31.543,31.543,0,0,1-30.6,30.6m0-18.5a12.932,12.932,0,0,0,12.1-12.1h8.4a21.352,21.352,0,0,1-20.5,20.5Zm0-10.2a2.79,2.79,0,0,0,1.9-1.9h8.5a11.265,11.265,0,0,1-10.4,10.4Zm31-3.6h-8.5a11.244,11.244,0,0,1,10.2-10.4V21.4a12.893,12.893,0,0,0-11.8,12.1h-8.4a21.393,21.393,0,0,1,20.3-20.5V11.4a23.054,23.054,0,0,0-21.9,22.2h-8.4A31.489,31.489,0,0,1,204.493,3V2a1.9,1.9,0,0,0-1.9-1.9h-34.6V34.4a3,3,0,0,0,2.1,2.8v8.5a11.349,11.349,0,0,1-10.5-11.3V0h-1.6V34.3a12.923,12.923,0,0,0,12.1,12.9v8.4a21.468,21.468,0,0,1-20.6-21.4V0h-1.6V34.3a23.044,23.044,0,0,0,22.2,23v8.4a31.424,31.424,0,0,1-30.6-31.4V0h-1.3a1.9,1.9,0,0,0-1.9,1.9V66.2a1.9,1.9,0,0,0,1.9,1.9h64.3a1.9,1.9,0,0,0,1.9-1.9V31.7a2.555,2.555,0,0,0-1.7,1.8";

/** LOS mark (the dock/arc emblem) on a navy tile; white tile with navy mark on dark surfaces; `bare` = the mark alone in navy. */
export const LosMark = ({ className, testId, tone = "ink" }) => {
  const tile = tone === "white" ? "white" : tone === "teal" ? "hsl(var(--teal))" : "hsl(var(--navy))";
  const mark = tone === "white" || tone === "bare" ? "hsl(var(--navy))" : "white";
  return (
    <svg viewBox="0 0 32 32" className={cn("shrink-0", className)} data-testid={testId} aria-hidden="true">
      {tone !== "bare" ? <rect width="32" height="32" rx="8" fill={tile} /> : null}
      <g transform={tone === "bare" ? "translate(1.5,1.5) scale(0.4466) translate(-136.293,0)" : "translate(5,5) scale(0.3216) translate(-136.293,0)"}><path d={MARK_D} fill={mark} /></g>
    </svg>
  );
};

/** Real LOS Marine logo (mark + LOS + MARINE). `variant` white for dark surfaces, dark (navy) for light. */
export const LosLogo = ({ variant = "dark", className, testId, withMark = false }) => (
  <span className={cn("inline-flex items-center gap-2.5", className)} data-testid={testId}>
    {withMark ? <LosMark className="h-[1.3em] w-[1.3em]" tone={variant === "white" ? "white" : "ink"} /> : null}
    <img
      src={variant === "white" ? "/brand/los-marine-logo-white.svg" : "/brand/los-marine-logo-navy.svg"}
      alt="LOS Marine"
      className="h-[1.25em] w-auto select-none"
      draggable={false}
    />
  </span>
);
